module.exports = __webpack_public_path__ + "static/transposh2-f59b22b96aa8665cf8b93e8c767bfe96.jpg";